import { render, staticRenderFns } from "./Destaque.vue?vue&type=template&id=cfd0b2fa&"
import script from "./Destaque.vue?vue&type=script&lang=js&"
export * from "./Destaque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports